import Lottie from 'lottie-web'
import { gsap } from 'gsap'
import DrawSVGPlugin from 'gsap/DrawSVGPlugin'
import ScrollTrigger from 'gsap/ScrollTrigger'
import { breakpointUp } from './utils/breakpoints'
import { setupWhyUsLottie } from './blocks/all-why-us'
import {animateAboutUs, setupAboutUsLottie, setupHeroLottie} from './blocks/about-us'

gsap.registerPlugin(DrawSVGPlugin, ScrollTrigger)

let animation = null
let pageLoaded = false
let lottieLoaded = false
let current_page = document.documentElement.getAttribute('data-page');
let current_url = document.documentElement.getAttribute('data-url');
const preloaderContainer = $('#preloader-logo-container')
const preloaderAnimate = $('#preloader-i-animate')
const path = preloaderContainer.data('logo-src')

const videoBlock = '#hero-video'
const imageBlock = '#header-image'

function iAnimationCompleted() {
  gsap.to('#preloader', { x: 0, duration: 0.5, onComplete: () => {
      $('html').removeClass('h-preloader')
    }
  })

  gsap.to('#preloader', { opacity: 0, duration: 1, onComplete: () => {
      $('#preloader').hide();
    }
  })

  if (isIndexPage()) {
    gsap.fromTo(videoBlock, { scale: 1.15 }, { scale: 1, duration: 1})
    gsap.fromTo('#animate-in', { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.50})
    window.sizeHeroVideo();
  }
  if (isServicesPage() || isNewsPage() || isAboutPage()) {
    gsap.fromTo(imageBlock, { scale: 1.15 }, { scale: 1, duration: 1 })
  }

  if (isAboutPage()) {
    gsap.fromTo('#animate-in', { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.50})
    setupAboutUsLottie();
    setupHeroLottie();
    animateAboutUs();
  }
  gsap.fromTo('.main-menu-links', { opacity: 0, y: -50 }, { opacity: 1, y: 0, duration: 0.25})
  initHeaderLine();
  setupWhyUsLottie();
}

$(window).on('load', function () {
  pageLoaded = true;
  if (sessionStorage.getItem('initialLoad') === null) {
    sessionStorage.setItem('initialLoad', 'true');
    document.documentElement.style.setProperty('--preloader-bg-color', '#D3B8AE');
    let svgContainer = document.getElementById('preloader-logo-container');

    animation = Lottie.loadAnimation({
      container: svgContainer,
      animType: 'svg',
      loop: false,
      autoplay: true,
      path: path
    });
    animation.addEventListener('complete', animationDone);
    animatePreloaderI();
  } else {
    document.documentElement.style.setProperty('--preloader-bg-color', '#824216');
    animatePreloaderII();
  }
});

function animatePreloaderI()
{
  if(!lottieLoaded || !pageLoaded) {
    return false
  }

  const rect = $('[mask="url(#__lottie_element_15_1)"]')[0].getBoundingClientRect()
  let topValue = rect.top + (rect.height / 2)
  let leftValue = rect.left + (rect.width / 2)

  $('#preloader-i-animate').css({
    top: topValue + 'px',
    left: leftValue + 'px',
    width: rect.width + 'px',
    height: rect.height + 'px'
  })

  preloaderAnimate.show()

  setTimeout(function () {
    let speed = 0.4
    if(breakpointUp('lg')) {
      speed = 0.8
    }

    gsap.to('#preloader-i-animate', { height: '105%', duration:speed })
    gsap.to('#preloader-i-animate', { width: '20%', duration: speed })
    gsap.to('#preloader-i-animate', { width: '110%', delay:speed, duration: speed, onComplete: iAnimationCompleted })
  }, 100)
}

function animatePreloaderII() {
  $('#preloader-loaded').addClass('preloader-loaded');
  $('#preloader-loaded').show();
  gsap.to('#preloader-loaded', { opacity: 0, duration: 0.5, onComplete: () => {
      $('#preloader-loaded').hide();
      iAnimationCompleted();
    }});
}

function animationDone() {
  lottieLoaded = true
  animatePreloaderI()
}

function initHeaderLine() {
  gsap.utils.toArray('.animation-line-header, .animation-line').forEach(element => {
    let path = $(element).find('path')
    let tl = gsap.timeline({ paused: true, repeat: 0, yoyo: false })
    tl.fromTo(path, { drawSVG: "100% 100%" }, { duration: 2, drawSVG: "0% 100%", delay: 0.1, stagger: 0.1 })
    tl.play()
  })
}

function isIndexPage() {
  return current_page === 'index';
}

function isServicesPage() {
  return current_page === 'services';
}

function isNewsPage() {
  return current_page === 'new-page';
}

function isAboutPage() {
  return current_page === 'about-us';
}
